import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import methodModel from '../../../methods/methods';
import Layout from '../../../components/global/layout';

const AddEditQuestion = () => {
  const { id, type } = useParams();
  const [question, setQuestion] = useState([
    {
      question: '',
      options: [
        { isChecked: false, name: '' },
        { isChecked: false, name: '' },
      ],
    },
  ]);

  const [form, setform] = useState({
    title: '',
    sub_title: '',
    image: [],
    document: [''],
    category_id: '',
  });
  const [title, settitle] = useState('');
  const [categories, setCategories] = useState([]);
  const [tab, setTab] = useState('info');
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [Types, setTypes] = useState();
  const user = useSelector((state) => state.user);
  const formValidation = [{ key: 'ques_ans', required: true }];
  const [num, setnum] = useState(1);
  const [data, setdata] = useState([]);



  const updatetag = (i, key, value, index) => {
    let arr = [...question];

    arr[index]['options'][i][key] = value;
    setQuestion([...arr]);
    setform({
      ...form,
      ques_ans: [...arr],
    });
    setnum(arr.length);
  };
  const updateQstData = (index, key, value) => {
    let arr = question;
    let obj = {};

    obj = { ...question[index], [key]: value };
    arr[index] = obj;
    setQuestion([...arr]);
    setform({
      ...form,
      ques_ans: [...arr],
    });
    setnum(arr.length);
  };
  const removeQuestionsData = (index) => {
    setQuestion([...question.filter((itm, i) => i != index)]);
    setform({
      ...form,
      ques_ans: [...question.filter((itm, i) => i != index)],
    });

    setnum(num - 1);
  };

  const AddQuestions = () => {
    question.push({ question: '', options: [{ isChecked: false, name: '' }] });
    setQuestion([...question]);
  };

  const DisableOtherCheckBox = (i, key, index) => {
    let arr = question;
    arr[index]['options']?.forEach((checkbox, key) => {
      if (key !== i) {
        checkbox.isChecked = false;
      }
    });
  };

  const removetag = (i, index) => {
    let arr = [...question];
    let fltr = arr[index]['options']?.filter((itm, key) => key != i);

    arr[index]['options'] = fltr;
    setQuestion([...arr]);
    setform({
      ...form,
      ques_ans: [...arr],
    });

    setnum(num - 1);
  };

  const AddTag = (i) => {
    let arr = question;
    arr[i]?.options?.push({ isChecked: false, name: '' });
    setQuestion([...question]);
  };

  const checksameOptioninquetions=(array)=>{
    let duplicate= false
    if(question?.length){
      for (let data=0; data<question?.length; data++){
        duplicate = findDuplicatesAndStop(question[data]?.options||[])
        if (duplicate?.length>0) {
          toast.error('Options cannot be same')
          break; // Exit the outer loop if a duplicate is found
      }
      }
    }
    
    return duplicate
  }
  const findDuplicatesAndStop=(arr)=> {
    let foundDuplicate = false;
    let duplicates = [];

    for (let i = 0; i < arr?.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
            if (arr[i]?.name.trim() === arr[j]?.name?.trim()) {
                duplicates.push(arr[i]?.name);
                foundDuplicate = true;
                break; // Exit the inner loop as soon as a duplicate is found
            }
        }
        if (foundDuplicate) {
            break; // Exit the outer loop if a duplicate is found
        }
    }
    return duplicates;
}

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);

    let invalid = methodModel.getFormError(formValidation, form);
    if (tab == 'seo' && invalid) {
      toast.error('Please fill Required Fields');
    }
    if(!title){
      return
    }
    if(checksameOptioninquetions(question)?.length>0){
      return
    }
    let isTrue = false;
    let OptionsNum = false;
    question?.map((itm) => {
      if (itm?.options?.length < 2) {
        OptionsNum = true;

        return (isTrue = true);
      }
      let selectedOptions = itm?.options?.filter(
        (item) => item?.isChecked == true
      );
      if (selectedOptions?.length === 0 && !isTrue) {
        isTrue = true;
        toast.error('Please choose correct answer');
      }
    });
    if (OptionsNum) { 
      toast.error('Please Add Atleast 2 Options');
    }

    // const allOptionNames = question.flatMap((question) =>
    //   question.options.map((option) => option.name.trim())
    // );
    // const uniqueNames = new Set(allOptionNames);
    // if (uniqueNames.size !== allOptionNames.length) {
    //   toast.error('You cannot submit because some options are duplicates.');
    //   return;
    // }


    if (isTrue) {
      return false;
    }

    if (invalid) return;
    let method = 'post';
    let url = 'question';
    let value = {
      ques_ans: question,
      title:title?.trim()
    };
    if (id) {
      method = 'put';
      url = 'question';
      value = {
        id: JSON.parse(id),
        question: question[0]?.question,
        options: question[0]?.options,
        title:title?.trim()
      };
    } else {
      value.addedBy = user._id;
      delete value.id;
    }
    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history('/questions');
      }
      loader(false);
    });
  };


  const getCategory = (t = type) => {
    ApiClient.get('CommonCategory/all', {
      page: 1,
      count: 100,
      type: 'blog',
      status: 'active',
    }).then((res) => {
      if (res.success) {
        setCategories(res.data);
      }
    });
  };


  const back = () => {
    history(-1);
  };

  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get('question', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setform({
            ...form,
            ques_ans: [
              { question: res?.data?.question, options: res?.data?.options },
            ],
          });
          settitle(res?.data?.title)
          setQuestion([
            { question: res?.data?.question, options: res?.data?.options },
          ]);

        }
        loader(false);
      });
    }
    getCategory();
  }, [id]);

  const GetCOurses = () => {
    ApiClient.get(`course/all`, { status: 'active', isDeleted: false }).then(
      (res) => {
        if (res.success) {
          let array = [];
          res?.data?.map((itm) => {
            array.push({ id: itm.id, name: itm.title });
          });
          setTypes(array);
        }
      }
    );
  };
  useEffect(() => {
    GetCOurses();
  }, []);

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? ' Edit ' : ' Add '}
                  Question
                </h3>
              </div>

              
            </div>

            <div className="grid grid-cols-12 gap-4">
              {tab == 'info' ? (
                <>
                <div className="col-span-12 md:col-span-12 mb-3">
                          <label>
                            Title<span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="relative shadow-box bg-white w-1/2 rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                            value={title}
                            onChange={(e) =>
                              settitle(prev=>{ return e.target.value})
                            }
                            required
                          />
                        </div>
                  {question?.map((item, index) => {
                    return (
                      <div className={`col-span-12 ${question?.length==1?"md:col-span-12":'md:col-span-6'} shadow-lg p-5 rounded-lg border border-[1px]`}>
                        <div className="col-span-12 md:col-span-6 mb-3">
                          <label>
                            Question<span className="star">*</span>
                          </label>
                          <input
                            type="text"
                            className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                            value={item?.question}
                            onChange={(e) =>
                              updateQstData(index, 'question', e.target.value)
                            }
                            required
                          />
                        </div>
                        <div className="border p-5 rounded-md bg-[#a7a7a745] mb-4">
                          <label>
                            Option<span className="star">*</span>
                          </label>
                          <div className="col-span-12 md:col-span-12">
                            <div className="div_questions  max-h-[310px] overflow-auto mb-[8px]">
                              {item?.options?.map((itm, i) => {
                                return (
                                  <div className="col-span-6 md:col-span-6 mb-3">
                                    <div className="relative">
                                      <div
                                        className="absolute_div"
                                        onChange={(e) => {
                                          if (num > data[0]?.sizeOfVenue) {
                                            removetag(i, index);
                                          }
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          name=""
                                          onChange={(e) => {
                                            DisableOtherCheckBox(
                                              i,
                                              e.target.checked,
                                              index
                                            );
                                            updatetag(
                                              i,
                                              'isChecked',
                                              e.target.checked,
                                              index
                                            );
                                          }}
                                          checked={itm?.isChecked}
                                          id={`AddMultipleQuestionsForQuestionBank${i}`}
                                        />
                                      </div>
                                      <div className="flex items-center">
                                        <input
                                          type="text"
                                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-10"
                                          value={itm?.name}
                                          onChange={
                                            (e) => {
                                              updatetag(
                                                i,
                                                'name',
                                                e.target.value,
                                                index
                                              );
                                            }
                                          }
                                          required
                                        />

                                        {i < 2 ? null : (
                                          <i
                                            className="trash_icon fa fa-trash pointer ml-2 absolute z-10 right-[0px] h-[34px] w-[34px] flex items-center justify-center border-[#603d42] border-l-[1px]"
                                            onClick={(e) => removetag(i, index)}
                                          ></i>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className="col-span-12 md:col-span-12 flex justify-between items-center">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => {
                                AddTag(index);
                              }}
                            >
                              <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                              Add Options
                            </button>
                            {index < 1 ? null : (
                              <i
                                className="fa fa-trash text-danger pointer bg-[#fff] ml-2 border w-[35px] h-[35px] flex justify-center items-center rounded-[50%] shadow"
                                onClick={(e) => removeQuestionsData(index)}
                              ></i>
                            )}
                          </div>
                          {/* )} */}
                        </div>
                      </div>
                    );
                  })}

                  {id ? null : (
                    <div className="col-span-12 md:col-span-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={AddQuestions}
                      >
                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add
                        Questions
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="col-span-12 md:col-span-12">
                    <label>URL Key</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.urlKey}
                      onChange={(e) =>
                        setform({ ...form, urlKey: e.target.value })
                      }
                    />
                    <div className="small">Leave empty to auto generate</div>
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaTitle}
                      onChange={(e) =>
                        setform({ ...form, metaTitle: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Description<span className="star">*</span>
                    </label>
                    <textarea
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaDescription}
                      onChange={(e) =>
                        setform({ ...form, metaDescription: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Keywords<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.keywords}
                      onChange={(e) =>
                        setform({ ...form, keywords: e.target.value })
                      }
                      required
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditQuestion;
